// extracted by mini-css-extract-plugin
module.exports = {"f-OrganismPostShareButton":"PostShareButton_f-OrganismPostShareButton__glKbw","f-OrganismPostShareButton-shareText":"PostShareButton_f-OrganismPostShareButton-shareText__6NjSo"};